import React from "react";
import { useHistory } from "react-router-dom";

import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Container from "../../../../components/Container";
import Button from "../../../../components/Button";
import birthPlan01 from "../../../../assets/images/birth-plan-01.png";
import LightPurpleContainer from "../../../../components/LightPurpleContainer";
import theme from "../../../../constants/theme";
import { routes } from "../../../../api/paths";

const useStyles = makeStyles(() =>
  createStyles({
    heading: {
      padding: theme.spacing(2, 0, 4, 0),
    },
    subheading: {
      paddingBottom: theme.spacing(3),
      fontSize: 18,
    },
    center: {
      textAlign: "center",
    },
  })
);

export default function Hero() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <LightPurpleContainer>
      <Container>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item md={6} xs={12}>
            <Typography variant="h3" className={classes.heading}>
              Plan poroda - put do vlastite odluke
            </Typography>
            <Typography className={classes.subheading}>
              Želite li sami otkriti spol djeteta? U kojem rodilištu želite da
              vaše dijete dođe na svijet? Imate li posebne zahtjeve za porod?
            </Typography>
            <Typography className={classes.subheading}>
              Kako bismo vam olakšale iskazati vaše želje, pripremile smo
              jednostavan način da kreirate vlastiti plan poroda.
            </Typography>
            <Button
              onClick={() => {
                history.push(routes.BIRTH_PLAN_FORM);
              }}
            >
              Napravite svoj Online plan poroda
            </Button>
          </Grid>
          <Grid item md={6} xs={12} className={classes.center}>
            <img
              src={birthPlan01}
              alt="plan poroda"
              style={{ width: "15rem" }}
            />
          </Grid>
        </Grid>
      </Container>
    </LightPurpleContainer>
  );
}
